import React from 'react';
import inviteBg from '@/common-pages/leaderboard/assets/invite.webp';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';

export default function InviteModal(props: {
  inviteScore: number;
  inviteCount: number;
}) {
  const {inviteScore, inviteCount} = props;
  const {goToNext} = useSequentialModalContext();
  return (
    <div
      className="w-[18.8125rem] h-[24.125rem] bg-full relative"
      onClick={goToNext}
      style={{
        backgroundImage: `url(${inviteBg})`,
      }}>
      <div className="absolute top-[9rem] w-full text-center text-[#A9987F] text-sm font-medium">
        Invited {inviteCount} users successfully
      </div>
      <div className="absolute top-[12.5rem] w-full text-center">
        <div className="text-[#83552D]  font-black">
          <span className="text-[3.5rem] leading-[2.75rem]">{inviteScore}</span>
          <span className="text-sm">Pts</span>
        </div>
        <div className="text-xs text-[#AE814A] font-medium mt-3">
          Earn pts reward
        </div>
      </div>
    </div>
  );
}
